// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advanced-search-active .btn-active-filter {
  background-color: red !important;
  border-color: red !important;
}

.menu-advanced-filter {
  min-width: 26vw !important;
}
.menu-advanced-filter .scroll-auto {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 40vh;
}
.menu-advanced-filter .label-filter-advanced {
  white-space: normal;
}
.menu-advanced-filter .btn-novitadimonds {
  height: 30px !important;
  border-radius: 6px !important;
  text-align: center !important;
  background-color: #dfa4a3 !important;
  font-size: 15px !important;
  font-family: "mreaves-regular";
  border-color: #dfa4a3 !important;
  color: #fff !important;
  width: auto !important;
  padding: 0px 10px;
}
.menu-advanced-filter .btn-novitadimonds:hover {
  color: #fff !important;
  background-color: #dfa4a3 !important;
  border-color: #dfa4a3 !important;
}
.menu-advanced-filter .btn-advanced-search {
  min-width: 170px;
}
.menu-advanced-filter .react-datepicker__navigation {
  display: grid !important;
  background: transparent !important;
  border: 0px !important;
}
.menu-advanced-filter .rbt-token-remove-button {
  background: #4a95f7 !important;
  border: 0px !important;
}
.menu-advanced-filter .react-datepicker-popper {
  z-index: 99999;
}
.menu-advanced-filter .nav-link {
  background: white !important;
  width: auto !important;
  border-radius: 0px !important;
  border-top-left-radius: var(--bs-nav-tabs-border-radius) !important;
  border-top-right-radius: var(--bs-nav-tabs-border-radius) !important;
  min-height: 35px !important;
  height: 100% !important;
  width: 100% !important;
}
.menu-advanced-filter .overflow-hidden {
  overflow: hidden;
}
.menu-advanced-filter .title-tab-advanced-filter {
  overflow-x: hidden !important;
}
.menu-advanced-filter .btn-novita-square-pink {
  border-radius: 5px !important;
  width: auto !important;
  padding: 5px !important;
}

@media only screen and (max-width: 1300px) {
  .menu-advanced-filter {
    min-width: 500px !important;
  }
}
@media only screen and (max-width: 500px) {
  .menu-advanced-filter {
    min-width: 100vw !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/advanced-filter.scss"],"names":[],"mappings":"AACI;EACI,gCAAA;EACA,4BAAA;AAAR;;AAIA;EACI,0BAAA;AADJ;AAGI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AAHR;AAMI;EACI,sBAAA;EACA,oCAAA;EACA,gCAAA;AAJR;AAOI;EACI,gBAAA;AALR;AAQI;EACI,wBAAA;EACA,kCAAA;EACA,sBAAA;AANR;AASI;EACI,8BAAA;EACA,sBAAA;AAPR;AAUI;EACI,cAAA;AARR;AAWI;EACI,4BAAA;EACA,sBAAA;EACA,6BAAA;EACA,mEAAA;EACA,oEAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;AATR;AAYI;EACI,gBAAA;AAVR;AAaI;EACI,6BAAA;AAXR;AAcI;EACI,6BAAA;EACA,sBAAA;EACA,uBAAA;AAZR;;AAgBA;EACI;IACI,2BAAA;EAbN;AACF;AAgBA;EACI;IACI,2BAAA;EAdN;AACF","sourcesContent":[".advanced-search-active {\n    .btn-active-filter {\n        background-color: red !important;\n        border-color: red !important;\n    }\n}\n\n.menu-advanced-filter {\n    min-width: 26vw !important;\n\n    .scroll-auto {\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 40vh;\n    }\n\n    .label-filter-advanced {\n        white-space: normal;\n    }\n\n    .btn-novitadimonds {\n        height: 30px !important;\n        border-radius: 6px !important;\n        text-align: center !important;\n        background-color: #dfa4a3 !important;\n        font-size: 15px !important;\n        font-family: 'mreaves-regular';\n        border-color: #dfa4a3 !important;\n        color: #fff !important;\n        width: auto !important;\n        padding: 0px 10px;\n    }\n    \n    .btn-novitadimonds:hover {\n        color: #fff !important;\n        background-color: #dfa4a3 !important;\n        border-color: #dfa4a3 !important;\n    }\n\n    .btn-advanced-search {\n        min-width: 170px;\n    }\n\n    .react-datepicker__navigation {\n        display: grid !important;\n        background: transparent !important;\n        border: 0px !important;\n    }\n\n    .rbt-token-remove-button {\n        background: #4a95f7 !important;\n        border: 0px !important;\n    }\n\n    .react-datepicker-popper {\n        z-index: 99999;\n    }\n\n    .nav-link {\n        background: white !important;\n        width: auto !important;\n        border-radius: 0px !important;\n        border-top-left-radius: var(--bs-nav-tabs-border-radius) !important;\n        border-top-right-radius: var(--bs-nav-tabs-border-radius) !important;\n        min-height: 35px !important;\n        height: 100% !important;\n        width: 100% !important;\n    }\n\n    .overflow-hidden {\n        overflow: hidden;\n    }\n\n    .title-tab-advanced-filter {\n        overflow-x: hidden !important;\n    }\n\n    .btn-novita-square-pink {\n        border-radius: 5px !important;\n        width: auto !important;\n        padding: 5px !important;\n    }\n}\n\n@media only screen and (max-width: 1300px) {\n    .menu-advanced-filter {\n        min-width: 500px !important;\n    }\n}\n\n@media only screen and (max-width: 500px) {\n    .menu-advanced-filter {\n        min-width: 100vw !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
